export default "__VITE_ASSET__CkvwPWxt__"